import type { CookieHelpers } from '@/utils/cookie';
import { getRequestContext } from '@/utils/headers';
import { isForeignEnvironment } from '../index';
import { validString } from './parse-app-data';
import type { AppData, NativeIdentity } from './types';

export function persistAppData({
	cookies,
	data,
}: {
	cookies: CookieHelpers;
	data: AppData;
}): NativeIdentity | undefined {
	const clientId = data.clientId || validString(cookies.getCookie('clientId'));
	if (!clientId || !isForeignEnvironment(clientId)) return undefined;
	// Resolve before replacing the client cookie: don't reuse another client's key.
	const { apiKey } = getRequestContext({
		clientId,
		apiKey: data.apiKey,
		getCookie: (key) => validString(cookies.getCookie(key)),
		ua: navigator.userAgent,
	});
	for (const [key, value] of Object.entries({
		clientId,
		apiKey,
		uuid: data.uuid,
		appVersion: data.appVersion,
	})) {
		if (!value) continue;
		cookies.clearCookie(key);
		cookies.setCookie(key, encodeURIComponent(value));
	}
	if (data.deviceId) {
		// Replace host-only shadows, and share device identity on ixigo hosts.
		cookies.clearCookie('ixiUID');
		const host = window.location.hostname;
		cookies.setCookie('ixiUID', encodeURIComponent(data.deviceId), {
			domain:
				host === 'ixigo.com' || host.endsWith('.ixigo.com')
					? '.ixigo.com'
					: undefined,
		});
	}
	cookies.syncCookies();
	return { clientId, apiKey };
}
